<fragment>
  <div
    v-if="getAttribute('showPreflight')"
    v-bind:class="useClassName"
  >
    <appPreflightInfo
      v-for="(item,index) in preflightData"
      v-bind:key="index"
      v-bind:propsData="item"
    >
    </appPreflightInfo>
  </div>
  <div
    v-if="!getIsPreflightCheckLoadingForProductPart()"
    v-bind:class="useClassName"
  >
  <!-- <div
    v-if="showPitstopInfo || showPitstopLoading && !getIsPreflightCheckLoading"
    v-bind:class="useClassName"
  > -->
    <div v-if="getIsPreflighPitstop && !wasPreflightExecutedSuccessfully()">
      {{ $t("The preflight check was not executed successfully")}}
    </div>
    <div v-else-if="getIsPreflighPitstop && wasPreflightExecutedSuccessfully() && getHasFullFunctionality">
      <div :class="getClassName + 'Header'">
        <span>{{$t('Pre-Flight Checks')}}</span>
        <a :href="getUploadedFileUrl('ReportPdf')" target="_blank">{{$t('(click here for detailed report)')}}</a>
      </div>
      <div :class="getClassName + 'Content'">
        <div v-if="showPreflightScriptLine('Warnings')" :class="getClassName + 'IssueTypeContainer'">
          <img :class="getClassName + 'IssueTypeContainerIcon'" :src="this.getBaseUrl + '/images/matrix/alert.svg'"/>
          <div :class="getClassName + 'IssueTypeContainerText'">{{ getUploadedFileData("Warnings") }} {{ $t('minor issues detected which may affect print quality') }}</div>
        </div>
        <div v-if="showPreflightScriptLine('Errors')" :class="getClassName + 'IssueTypeContainer'">
          <img :class="getClassName + 'IssueTypeContainerIcon'" :src="this.getBaseUrl + '/images/matrix/error.svg'"/>
          <div :class="getClassName + 'IssueTypeContainerText'">{{ getUploadedFileData("Errors") }} {{ $t('critical issues detected which must be resolved before printing') }}</div>
        </div>
        <div v-if="showPreflightScriptLine('NoIssues')" :class="getClassName + 'IssueTypeContainer'">
          <img :class="getClassName + 'IssueTypeContainerIcon'" :src="this.getBaseUrl + '/images/matrix/checkmark.png'"/>
          <div :class="getClassName + 'IssueTypeContainerText'">{{$t('No issues detected. Your artwork is ready to print')}}</div>
        </div>
      </div>
    </div>
    <!-- <appPreflightInfo
      v-if="showPitstopInfo"
      v-for="(item,index) in showPitstopInfo"
      v-bind:key="index"
      v-bind:propsData="item"
    >
    </appPreflightInfo>
    <div v-if="showPitstopLoading">
      <appUploadLoading></appUploadLoading>
    </div> -->
  </div>
  <div class="matrix_customLoaderContainer" v-else>
    <appCustomLoader></appCustomLoader>
    <div class="matrix_customLoaderContainerText" v-html="getCheckText">
      <!-- {{ $t('Checking your file') }} -->
    </div>
    <!-- <appUploadLoading></appUploadLoading> -->
  </div>
</fragment>